// UserSession.ts
import { bearerAuthHeader, putVoid } from "../ChoiceApi";
import { timeout } from "../ChoiceUtils";
import { getSessionPulseToken } from "./User";
import jwt_decode from "jwt-decode";

// Update the session
async function pulseSession(pulseJwt: string): Promise<boolean>{
    let result = true;
    await putVoid("api/UserSession/Pulse", undefined, 
    { 
        errorCallback: err => { result = false},
        headers: bearerAuthHeader(pulseJwt),
        automatedCall: true
    });
    return result;
}

export class PulseSession
{
    pulseRunning: boolean = false;
    intervalInSeconds: number = 15;

    constructor(intervalInSeconds?: number)
    {
        if (intervalInSeconds && intervalInSeconds > 0)
            this.intervalInSeconds = intervalInSeconds;
    }

    async start()
    {
        this.pulseRunning = true
        while (this.pulseRunning)
        {
            await timeout(1000);
    
            // Get the pulse token
            const jwtResp = await getSessionPulseToken();

            // Failure indicates the session is no longer valid
            if ((!jwtResp) || (false === jwtResp.success))
                return;

            const jwt = jwtResp.data;
            if (!jwt)
                continue;
    
            const jwtData = jwt_decode<{ exp?: number }>(jwt);
            if (!jwtData.exp)
                continue;
    
            // Trim 30 seconds off the expiration timestamp for the JWT
            const jwtExpiration = new Date((jwtData.exp - 30) * 1000)
    
            while (this.pulseRunning && new Date() < jwtExpiration)
            {
                await timeout(1000 * this.intervalInSeconds);
                const result = await pulseSession(jwt);
                if (!result)
                    break;
            }
        }
    }
    
    stop()
    {
        this.pulseRunning = false;
    }    
}